export type SecondaryDimensionValues =
  | 'timeseries'
  | 'rics'
  | 'geography'
  | 'role'
  | 'company'
  | 'skills'
  | 'gender'
  | 'ethnicity'
  | 'education'
  | 'seniority'
  | 'competitors';

export type EntityType = 'company' | 'geography' | 'role';

export type SecondaryDimensionOption = {
  value: SecondaryDimensionValues;
  label: string;
};

export const secondaryDimensionOptions: SecondaryDimensionOption[] = [
  { value: 'timeseries', label: 'Timeseries' },
  { value: 'competitors', label: 'Competitors' },
  { value: 'rics', label: 'Industry' },
  { value: 'geography', label: 'Geography' },
  { value: 'role', label: 'Role' },
  { value: 'company', label: 'Company' },
  { value: 'skills', label: 'Skill' },
  { value: 'gender', label: 'Gender' },
  { value: 'ethnicity', label: 'Ethnicity' },
  { value: 'education', label: 'Education' },
  { value: 'seniority', label: 'Seniority' },
];
